import React, { useState } from 'react';
import './Layers.css';

const Layers = ({ project }) => {
  const [viewState, setViewState] = useState('Default');
  const [filter, setFilter] = useState('');
  const [sortBy, setSortBy] = useState('name');

  const layers = [
    {
      id: 1,
      name: 'Group: Model-260-1',
      type: 'group',
      opacity: 100,
      visible: true,
      expanded: false
    }
  ];

  return (
    <div className="layers-container">
      <div className="layers-controls">
        <div className="control-group">
          <label>View state:</label>
          <div className="view-state-controls">
            <select 
              value={viewState} 
              onChange={(e) => setViewState(e.target.value)}
              className="view-state-select"
            >
              <option value="Default">Default</option>
              <option value="Custom 1">Custom 1</option>
              <option value="Custom 2">Custom 2</option>
            </select>
            <div className="view-state-actions">
              <button className="action-btn" title="Add New View State">
                <i className="fas fa-plus"></i>
              </button>
              <button className="action-btn" title="Save View State">
                <i className="fas fa-save"></i>
              </button>
              <button className="action-btn" title="Apply View State">
                <i className="fas fa-check"></i>
              </button>
              <button className="action-btn" title="Delete View State">
                <i className="fas fa-trash"></i>
              </button>
            </div>
          </div>
        </div>

        <div className="control-group">
          <label>Filter:</label>
          <input
            type="text"
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            placeholder="Filter layers..."
            className="filter-input"
          />
        </div>
      </div>

      <div className="layers-list">
        <div className="layers-header">
          <div className="header-cell sortable" onClick={() => setSortBy('name')}>
            <span>Name</span>
            <i className={`fas fa-arrow-up ${sortBy === 'name' ? 'active' : ''}`}></i>
          </div>
          <div className="header-cell">Opacity</div>
          <div className="header-cell">Drop</div>
        </div>

        <div className="layers-content">
          {layers.map(layer => (
            <div key={layer.id} className="layer-item">
              <div className="layer-main">
                <button className="layer-expand-btn">
                  <i className={`fas fa-chevron-right ${layer.expanded ? 'expanded' : ''}`}></i>
                </button>
                <div className="layer-info">
                  <span className="layer-name">{layer.name}</span>
                </div>
                <div className="layer-actions">
                  <button className="layer-action-btn" title="Layer Settings">
                    <i className="fas fa-wrench"></i>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Layers;